/**
 * LifeRamp
 *
 * @author      Moin Khan
 * @copyright   LifeRamp Inc.
 *
 * Built by Eonyx Infotech LLP.
 * @link https://eonyx.io
 *
 */
import React from "react";
import { Route } from "react-router-dom";

import PostList from "./PostList";
import PostAddEdit from "./PostAddEdit";

function Posts() {
    return (
        <>
            <Route path="/admin/posts" exact component={PostList} />
            <Route path="/admin/posts/addEdit" exact component={PostAddEdit} />
        </>
    );
}

export default Posts;
